import {
  Admin,
  AppBar,
  CustomRoutes,
  defaultTheme,
  Layout,
  Logout,
  MenuItemLink,
  Resource,
  UserMenu
} from 'react-admin';
import { Dashboard } from './modules/dashboard';
import teacher from './modules/orders/teacher'
import bulk from './modules/orders/bulk'
import schooldelivery from './modules/orders/student/schoolDelivery'
import homeDelivery from './modules/orders/student/homeDelivery'
import { LoginPage } from './modules/auth';
import dataProvider from './data.provider';
import authProvider from './authProvider';
import { SettingsScreen } from './modules/admin/Settings.screen';
import { Route } from 'react-router-dom';
import SchoolIcon from '@mui/icons-material/School';
import GridOnTwoToneIcon from '@mui/icons-material/GridOnTwoTone';
import HomeIcon from '@mui/icons-material/Home';
import { Menu } from './modules/admin/Menu';
import ListAltTwoToneIcon from '@mui/icons-material/ListAltTwoTone';
import { StudentOrder } from './modules/orders/student/StudentOrder.show';
import { orange } from '@mui/material/colors';
import { ShippedStudentOrders } from './modules/orders/student';
import { PrintLog } from './modules/admin/Print.log';
import { CustomLabelsScreen } from './modules/customLabels';

const theme = {
  ...defaultTheme,
  palette: {
    primary: { main: '#43a441'},
    secondary: orange
  }
}

const ZUserMenu = (props) => (
  <UserMenu {...props}>
    <MenuItemLink
      to="/settings"
      primaryText="Settings" />

    <MenuItemLink
      to="/printlog"
      primaryText="Print Log" />
    <Logout />
  </UserMenu>
)

const zAppBar = (props) => <AppBar {...props} color='primary' userMenu={<ZUserMenu />} />
const zLayout = (props) => <Layout {...props} appBar={zAppBar} />

const App = () => (
  <Admin
    theme={theme}
    menu={Menu}
    layout={zLayout}
    authProvider={authProvider}
    dataProvider={dataProvider}
    loginPage={LoginPage}
    dashboard={Dashboard}
    disableTelemetry>

    <Resource name='TeacherOrder' {...teacher} options={{
        label: 'Teacher Orders'
    }}  icon={ListAltTwoToneIcon} />

    <Resource name='StudentOrderHome' {...homeDelivery} options={{
        label: 'Student Home Delivery'
    }}  icon={HomeIcon} />

    <Resource name='StudentOrderSchool' {...schooldelivery} options={{
        label: 'Student School Delivery'
    }}  icon={SchoolIcon} />

    <Resource name='BulkOrder' {...bulk} options={{
      label: 'Bulk Orders'
    }} icon={GridOnTwoToneIcon} />

    <CustomRoutes>
      <Route path='/settings' element={<SettingsScreen />} />
      <Route path='/shipped/student' element={<ShippedStudentOrders />} />
      <Route path='/shippedStudentOrder/:id/show' element={<StudentOrder />} />
      <Route path='/printlog' element={<PrintLog />} />
      <Route path='/custom-labels' element={<CustomLabelsScreen />} />
    </CustomRoutes>

  </Admin>
)

export default App;
